var _excluded = ["imgSize", "urls", "remainingItemsCount"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import avatar from '../../../assets/images/google_profile.jpg';
import './avatars.scss';
var Avatars = function Avatars(_ref) {
  var imgSize = _ref.imgSize,
    urls = _ref.urls,
    remainingItemsCount = _ref.remainingItemsCount,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "avatars avatars-".concat(imgSize)
  }, urls.map(function (url, index) {
    return /*#__PURE__*/React.createElement("div", Object.assign({
      key: index + 1,
      className: "avatar"
    }, rest), /*#__PURE__*/React.createElement("img", {
      src: url || avatar,
      alt: "user avatar"
    }));
  }), remainingItemsCount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center avatar product-dark-color"
  }, /*#__PURE__*/React.createElement("span", {
    className: "fs-3 fw-bold"
  }, "+", remainingItemsCount)));
};
Avatars.defaultProps = {
  imgSize: 'md'
};
export default Avatars;